import React, { useEffect, useState } from "react";
import SVGraphics from "../../assets/SVGraphics";
import CustomDropdown from "../input/CustomDropdown";
import { Error } from "../forms/Error";
import utils from "../../utils/utils";
import SettingsContent from "./Settings";
import { ReactComponent as SettingsIcon } from "../../assets/settings.svg";
const PopUpWindow = (props) => {
  const [entry, setEntry] = useState(() => {
    const initialEntry = {};

    props.formSections?.forEach((section) => {
      section.inputs?.forEach((input) => {
        initialEntry[input.name] = "";
      });
    });

    props.additionalForm?.forEach((item) => {
      initialEntry[item.key] = item.value;
    });

    return { ...initialEntry, ...props.editEntry };
  });

  const [error, setError] = useState({});
  const { formSections } = props;

  const onChange = async (name, value) => {
    const updatedEntry = { ...entry, [name]: value };
    const newErrors = { ...error };
  
    // find field config
    const allInputs = (formSections || []).flatMap((section) => section.inputs || []);
    const fieldDef = allInputs.find((i) => i.name === name);
  
    // required validation
    if (fieldDef?.required) {
      if (!value || value.trim() === "") {
        newErrors[name] = `${fieldDef.label} is required`;
      } else {
        delete newErrors[name];
      }
    }
  
    // Email validation - check by type instead of name
    if (fieldDef?.type === "email") {
      if (value && !utils.mailValidation(value)) {
        newErrors[name] = "Please enter valid Email";
      } else if (fieldDef?.required && !value) {
        newErrors[name] = "Please enter Email";
      } else {
        delete newErrors[name];
      }
    }
  
    // Phone validation - check by type instead of name
    if (fieldDef?.type === "phone") {
      if (value && !utils.phoneValidation(value)) {
        newErrors[name] = "Please enter valid phone number";
      } else if (fieldDef?.required && !value) {
        newErrors[name] = "Please enter phone number";
      } else {
        delete newErrors[name];
      }
    }
  
    // re-run schema if needed
    if (props.validateSchema && error[name]) {
      await validateForm(updatedEntry);
    }
  
    setEntry(updatedEntry);
    setError(newErrors);
  };

  const allInputs = (formSections || []).flatMap(
    (section) => section.inputs || []
  );
  
  const requiredFieldNames = allInputs
    .filter((input) => input.required)
    .map((input) => input.name);
  
  const isSubmitDisabled =
    // any required field empty
    requiredFieldNames.some((name) => !entry[name] || entry[name] === "") ||
    // or any current errors
    Object.keys(error).length > 0;
  
  

  const submitItems = async () => {
    let validateEntry = await validateForm(entry);
    if (!validateEntry) props.handlePostApi(entry);
  };

  const validateForm = async (currentEntry) => {
    let value = false;
    let formErrors = {};
    if (!props.validateSchema) return false;
    await props.validateSchema
      .validate(currentEntry, { abortEarly: false })
      .then(() => {
        setError(formErrors);
      })
      .catch((err) => {
        err.inner.forEach((error) => {
          formErrors[error.path] = error.errors;
        });
        value = true;
        setError(formErrors);
      });
    return value;
  };

  const getInputByType = (input) => {
    if (input.type === "input") {
      return (
        <input
          type="text"
          id={input.name}
          name={input.name}
          placeholder={input.placeholder || ""}
          className={`p-4 h-14 rounded-lg focus:outline-none bg-[#0000004D] text-[#FFFFFF] ${
            input.readOnly ? "opacity-60 cursor-not-allowed" : ""
          }`}
          value={entry[input.name] || ""}
          readOnly={input.readOnly || false}
          onChange={(e) =>
            !input.readOnly && onChange(input.name, e.target.value)
          }
        />
      );
    }
  
    if (input.type === "email") {
      return (
        <input
          type="email"
          id={input.name}
          name={input.name}
          placeholder={input.placeholder || ""}
          className={`p-4 h-14 rounded-lg focus:outline-none bg-[#0000004D] text-[#FFFFFF] ${
            error[input.name] ? "border border-red-500" : ""
          }`}
          value={entry[input.name] || ""}
          onChange={(e) => onChange(input.name, e.target.value)}
        />
      );
    }
  
    if (input.type === "phone") {
      return (
        <input
          type="tel"
          id={input.name}
          name={input.name}
          placeholder={input.placeholder || ""}
          className={`p-4 h-14 rounded-lg focus:outline-none bg-[#0000004D] text-[#FFFFFF] ${
            error[input.name] ? "border border-red-500" : ""
          }`}
          value={entry[input.name] || ""}
          onChange={(e) => onChange(input.name, e.target.value)}
        />
      );
    }
  
    if (input.type === "dropdown" || input.type === "select") {
      let placeholderText = "Sites";
      if (props.isEditMode) {
        placeholderText = input.data?.[0]?.label || "Sites";
      }
  
      return (
        <CustomDropdown
          variant="outlined"
          value={entry[input.name] || ""}
          onChange={onChange}
          name={input.name}
          className="min-w-[124px] font-white max-h-10 border-[#FFFFFF]"
          label=""
          data={input.data || []}
          placeholder={placeholderText}
        />
      );
    }
  
    return null;
  };

  const getAdditionalForm = () => {
    const additionalRows = props.additionalForm || [];
    if (additionalRows.length === 0) return null;

    return (
      <div className="w-full grid grid-cols-1 gap-8 border-t border-[#999999] mt-8 pt-8">
        {additionalRows.map((item, i) => (
          <div className="flex" key={i} id={item.key}>
            <div className="grid grid-cols-1 gap-3" style={{ width: "458px" }}>
              <h3 className="text-sm font-semibold text-[#FFFFFF]">
                {item.key}
              </h3>
              <div className="text-sm font-semibold text-[#FFFFFF]">
                {item.text}
              </div>
            </div>
            <CustomDropdown
              variant="outlined"
              value={entry[item.key] || item.value}
              onChange={onChange}
              name={item.key}
              className="min-w-[124px] font-white ml-auto max-h-10 border-[#FFFFFF]"
              label=""
              data={item.options}
            />
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-opacity-50 backdrop-blur-sm z-50 p-4">
      <div
        className="bg-[#2E2E2E] pt-4 pb-3 rounded-md shadow-lg w-full max-w-[689px] max-h-[90vh] overflow-y-auto"
        style={{ minHeight: "400px" }}>
        {/* Header */}
        <div className="flex w-full px-8">
          <div className="flex items-center gap-1">
            {props.popupTitle.toLowerCase() === "settings" && (
              <SettingsIcon
                className="w-[22px] h-[22px] text-white"
                fill="white"
              />
            )}
            {props.popupTitle.toLowerCase() === "account" && (
              <SVGraphics
                svgname="AccountIcon"
                className="w-[22px] h-[22px] text-white"
                fill="white"
              />
            )}{" "}
            <span className="font-Inter text-base text-[#FFFFFF] text-[17px]">
              {props.popupTitle ||
                (props.isEditMode ? "Edit Site" : "Site Info")}
            </span>
          </div>
          <SVGraphics
            fill="none"
            className="ml-auto w-5 h-5 cursor-pointer group"
            onClick={props.closePopUp}
            svgname="PopUpClose"
          />
        </div>

        <div className="px-8 border-t border-[#999999] mt-6 pb-7">
          {/* Settings Mode */}
          {props.popupTitle === "settings" ? (
            <SettingsContent />
          ) : props.popupTitle === "Site Info" ? (
            // Read-only Info View - ONLY for Site Info
            <div className="flex flex-col gap-6 mt-6 text-white">
              {/* Logo + Name Row */}
              <div className="flex items-start gap-6">
                <div className="flex justify-center items-center w-[80px] h-[80px] bg-[#3A3A3A] rounded-md">
                  {props.editEntry?.Site_logo ? (
                    <img
                      src={props.editEntry.Site_logo}
                      alt="Site Logo"
                      className="max-w-[80px] max-h-[80px] object-contain"
                    />
                  ) : (
                    <SVGraphics
                      svgname="PlusIcon"
                      className="w-6 h-6 text-gray-400"
                    />
                  )}
                </div>
                <div className="flex flex-col gap-6">
                  <div>
                    <h3 className="text-white text-[18px] mb-1">Name</h3>
                    <p className="text-[16px]">{props.editEntry?.Site_name}</p>
                  </div>

                  {/* Contact Details */}
                  <div>
                    <h3 className="text-white text-[18px] mb-1">
                      Provider contact details
                    </h3>
                    <p className="text-[16px]">
                      {props.editEntry?.Site_contact_email}
                    </p>
                    <p className="text-[16px]">
                      {props.editEntry?.Site_contact_phone}
                    </p>
                    <p className="text-[16px]">
                      {props.editEntry?.Site_contact_firstname}{" "}
                      {props.editEntry?.Site_contact_lastname}
                    </p>
                  </div>

                  {/* Address */}
                  <div>
                    <h3 className="text-white text-[18px] mb-1">Address</h3>
                    <p className="text-[16px]">
                      {props.editEntry?.Site_address}{" "}
                      {props.editEntry?.Site_city} {props.editEntry?.Site_state}
                    </p>
                    <p className="text-[16px]">
                      {props.editEntry?.Site_country}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            // Edit/Create Form - for BOTH Create Site and Edit Site
            <form>
               {Array.isArray(formSections) &&
                 formSections.map((section, sectionIndex) => (
                   <div
                     key={sectionIndex}
                     className="grid grid-cols-1 gap-6 font-Inter mt-6"
                   >
                     {section.showTitle && (
                       <h3 className="text-sm font-semibold text-[#999]">
                         {section.title}
                       </h3>
                     )}
                     <div className="grid gap-6 grid-cols-2">
                       {section.inputs.map((input, inputIndex) => (
                         <div
                           key={inputIndex}
                           className={`${
                             input.fullRow ? "col-span-2" : "col-span-1"
                           } flex flex-col gap-4`}
                         >
                           <div className="flex">
                              <label
      htmlFor={input.name}
      className="text-base text-[#FFFFFF]"
    >
      {input.label}
      {input.required && (
        <span className="text-[#FF5A5A] ml-1">*</span>
      )}
                              </label>
                          </div>  
                              {/* INPUT FIELD */}
                                {getInputByType(input)} 
                              {/* ERROR MESSAGE UNDER INPUT */}
                              <Error
                                message={error[input.name]}
                                isShown={error[input.name]}
                              />                             
                         </div>
                       ))}
                     </div>
                   </div>
                 ))}
               {getAdditionalForm()}
              </form>

          )}
        </div>

        {/* Footer Buttons: Show for Create and Edit, not for Info or Settings */}
        {props.popupTitle !== "Site Info" &&
          props.popupTitle !== "settings" && (
            <div className="flex justify-end mt-8 px-8 gap-4">
              <button
                type="button"
                className="w-31 h-10 bg-transparent px-4 py-2.5 text-sm text-white rounded-lg border"
                onClick={props.closePopUp}>
                Cancel
              </button>
              <button
                type="button"
                onClick={submitItems}
                disabled={isSubmitDisabled}
                className={`w-36 h-10 px-4 py-2 text-white rounded-lg ${
                  isSubmitDisabled ? "opacity-50 cursor-not-allowed" : ""
                }`}
                style={{ backgroundColor: "#5A3EFF" }}
              >
                {props.isEditMode ||
                props.popupTitle?.toLowerCase() === "account"
                  ? props.updateText || "Update"
                  : props.submitText || "Create"}
              </button>

            </div>
          )}
      </div>
    </div>
  );
};

export default PopUpWindow;
